export const LEFT_MENU_WIDTH = 240;
export const DISCLAIMER_MARGIN = 20;
